import { Box, Grid, styled, Tab, Tabs } from '@mui/material';

export const StyledForm = styled(Box)({
  width: '100%',
});

export const FormNavigation = styled(Grid)({
  boxSizing: 'border-box',
  background: '#FFFFFF',
  border: '1px solid #C0C7CA99',
  borderRadius: '8px 0px 0px 8px',
  height: 'auto',
  overflow: 'hidden',
  width: 'max-content',
});

export const FormContent = styled(Grid)({
  boxSizing: 'border-box',
  background: '#FFFFFF',
  border: '1px solid #C0C7CA99',
  borderRadius: '0px 8px 8px 0px',
  borderLeft: 'unset',
  height: 'auto',
  overflow: 'hidden',
});

export const FormAction = styled(Box)({
  marginTop: '20px',
  display: 'flex',
  justifyContent: 'end',
  gap: '10px',
});

export const StyledTabs = styled(Tabs)({
  padding: '0 0px',
  '& .MuiTabs-indicator': {
    width: '4px',
    left: '0',
    height: '30px',
    marginTop: '8px',
  },
});

export const StyledTab = styled(Tab)(({ theme }) => ({
  padding: '0 16px',
  marginRight: 'auto',
  textTransform: 'capitalize',
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: '500',
  fontSize: '16px',
  lineHeight: '24px',
  color: '#6B7280',
  '& .Mui-selected': {
    color: theme.palette.primary.main,
  },
}));
